/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications
    },
    // REMOVE_RECORD(state, itemId) {
    //     const exhibitorIndex = state.notifications.findIndex((u) => u.Email === itemId)
    //     state.notifications.splice(exhibitorIndex, 1)
    // }
    SET_GROUPS(state, groups) {
        state.groups = groups
    },
}